"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _reduxFalcor = require("../redux-falcor");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$mapStateToPr = options.mapStateToProps,
      mapStateToProps = _options$mapStateToPr === void 0 ? function () {
    return {};
  } : _options$mapStateToPr,
      _options$mapDispatchT = options.mapDispatchToProps,
      mapDispatchToProps = _options$mapDispatchT === void 0 ? null : _options$mapDispatchT;

  var mS2P = function mS2P(state, props) {
    return _objectSpread(_objectSpread({}, mapStateToProps(state, props)), {}, {
      falcorCache: state.falcorCache
    });
  };

  return (0, _reactRedux.connect)(mS2P, mapDispatchToProps)((0, _reduxFalcor.reduxFalcor)(Component));
};

exports["default"] = _default;